import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
import { translations } from "@aws-amplify/ui-react";
import { I18n } from "aws-amplify/utils";

import { awsConfig } from "./aws-config";

const configAmplify = () => {
  const authConfig = {
    Cognito: {
      region: "ap-northeast-1",
      userPoolId: awsConfig.UserPoolId,
      userPoolClientId: awsConfig.UserPoolClientId,
    },
  };

  const APIConfig = {
    REST: {
      public: {
        // 未認証ユーザー用エンドポイント
        endpoint: awsConfig.ServiceEndpoint,
        region: "ap-northeast-1",
      },
      authenticated: {
        // 認証済みユーザー用エンドポイント
        endpoint: awsConfig.ServiceEndpoint,
        region: "ap-northeast-1",
      },
    },
  };

  Amplify.configure(
    {
      Auth: authConfig,
      API: APIConfig,
    },
    {
      API: {
        REST: {
          headers: async () => {
            const authSession = await fetchAuthSession();
            return {
              Authorization: authSession.tokens?.idToken?.toString(),
              "Content-Type": "application/json",
              // バックエンドで PostHog のプロジェクトを振り分けるためのヘッダー
              "X-Posthog-Project-Token": import.meta.env.VITE_POSTHOG_PROJECT_TOKEN_RECEPTION ?? "",
            };
          },
        },
      },
    }
  );

  I18n.putVocabularies(translations);
  I18n.setLanguage("jp");

  I18n.putVocabularies({
    jp: {
      "Sign In": "ログイン",
      "Create Account": "アカウントを作成する",
      Username: "ユーザー名",
      Password: "パスワード",
      "Confirm Password": "パスワードを認証する",
      "Sign in": "ログイン",
      "Signing in": "サインイン",
      "Enter your Username": "ユーザー名を入力して下さい",
      "Enter your Password": "パスワードを入力してください",
      "Enter confirm your Password": "確認用のパスワードを入力してください",
      "Forgot your password?": "パスワードをお忘れの場合?",
    },
  });
};

export default configAmplify;
